import React, { ComponentType } from "react";
import { hydrateRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import tvgConf from "@tvg/conf";
import Registration from "@tvg/gtm/src/modules/Registration";
import configureStore from "./configureStore";
import Main from "./pages";

interface Message {
  type: string;
  body?: object;
}

// eslint-disable-next-line no-underscore-dangle
const preloadedState = window.__REGISTRATION_PRELOADED_STATE__;

window.handleNativeMessages = (type: string, body?: object) => {
  if (window?.ReactNativeWebView) {
    const { postMessage } = window.ReactNativeWebView;
    const message: Message = {
      type: ""
    };

    message.type = type;
    if (body) {
      message.body = body;
    }
    postMessage(JSON.stringify(message));
  }
};

// random gui from the net...
const guid = () => {
  const s4 = () =>
    Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);

  return `${s4() + s4()}-${s4()}-${s4()}-${s4()}-${s4()}${s4()}${s4()}`;
};

// testing new RN message system
window.promiseChain = Promise.resolve();
window.callbacks = {};

window.nativeBridge = (
  type: string,
  data: object,
  success: object,
  error: object
) => {
  const msgObj = {
    type,
    body: data || {},
    msgId: ""
  };

  if (success || error) {
    msgObj.msgId = guid();
  }

  const msg = JSON.stringify(msgObj);

  // @ts-ignore
  window.promiseChain = window.promiseChain
    .then(
      () =>
        new Promise((resolve) => {
          console.log(`sending message ${msgObj.type}`);

          if (msgObj.msgId !== "") {
            // @ts-ignore
            window.callbacks[msgObj.msgId] = {
              onsuccess: success,
              onerror: error
            };
          }

          window.ReactNativeWebView.postMessage(msg);

          // @ts-ignore
          resolve();
        })
    )
    .catch((e) => {
      console.error(`nativeBridge promise failed ${e.message}`);
    });
};

// GTM subscribers event init
Registration();

const store = configureStore(preloadedState);
// gets conf for specific host / device
tvgConf(window.location.hostname, window.navigator.userAgent);

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const hotRender = (App: ComponentType<any>) =>
  document.getElementById("registration") &&
  hydrateRoot(
    // @ts-ignore
    document.getElementById("registration"),
    <Provider store={store}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Provider>
  );

export default hotRender(Main);
